import { apiGet } from "../../utils"

export function getMusilinksHistoryAdminAPI(data) {
    return apiGet('/api/getMusilinksHistoryAdmin', data)
}

export function getMusilinksUsersAdminAPI(data) {
    return apiGet('/api/getMusilinksUsersAdmin', data)
}
